import React, { useCallback, useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import _isEmpty from 'lodash/isEmpty';
import _noop from 'lodash/noop';
import { getAnnotationStyle } from '../../../../../../common/utils/utils';
import { getRandomId } from '../../../../../../common/utils/utils';
import { isVideoLabelingM4EnabledAtom } from '../../../../../labelling-v2/atoms/m4-atoms';
import { useStageAtoms } from '../../../../../labelling-v2/components/stage-scope/hooks';
import { ANNOTATION_SHAPE_STYLING_TYPE, SAM_ANNOTATION_ACTIONS } from '../../../../constants';
import { useSamForReview } from '../../../../providers/hooks/use-sam-for-review';
import Shape from '../../shape/shape';
import { getStylesForStylingType } from '../../utils';
import { getRectangleVertices } from '.././utils';
import useRectangle from '../hooks/useRectangle';
const ROTATION_ANGLE = 0;
const BoundingBox = ({
  isPolygon
}: {
  isPolygon?: boolean;
}) => {
  const [isDrawingComplete, setIsDrawingComplete] = useState(false);
  const {
    currentFrameAtom,
    currentFrameAnnotationUnderUserReviewAtom
  } = useStageAtoms();
  const currentFrame = useAtomValue(currentFrameAtom);
  const annotationUnderUserReview = useAtomValue(currentFrameAnnotationUnderUserReviewAtom);
  const isVideoLabelingM4Enabled = useAtomValue(isVideoLabelingM4EnabledAtom);
  const {
    addSamAnnotationForReview
  } = useSamForReview();
  const onRectangleCreation = useCallback(
  // TODO: Fix type error TOPENG-32943
  rect => {
    setIsDrawingComplete(true);
    if (rect === undefined || rect === null) return;
    addSamAnnotationForReview(getRandomId(), {
      type: isPolygon ? SAM_ANNOTATION_ACTIONS.BOUNDING_BOX_POLYGON : SAM_ANNOTATION_ACTIONS.BOUNDING_BOX,
      annotationMetaData: [{
        ...rect
      }],
      frameIndex: currentFrame
    });
  }, [addSamAnnotationForReview, currentFrame, isPolygon]);
  useEffect(() => {
    const hasAnnotationUnderReview = !_isEmpty(annotationUnderUserReview);
    if (!hasAnnotationUnderReview) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsDrawingComplete(false);
    }
  }, [annotationUnderUserReview]);
  const {
    rect,
    labelCoords,
    centerCoords
  } = useRectangle(!isDrawingComplete, {
    onRectangleCreation
  });
  if (!rect) return null;
  const vertices = getRectangleVertices(rect.data);
  const annotationStyle = getAnnotationStyle(rect.annotationLabel.style, {
    isFocused: false,
    isLocked: false,
    useStageStrokeWidth: true,
    isM4: isVideoLabelingM4Enabled
  });
  return <Shape vertices={vertices} isLocked={false} annotationLabel={{
    ...rect.annotationLabel,
    labelCoords
  }} onVertexSelect={_noop} rotationAngle={rect.data ? rect.data.rotationAngle : ROTATION_ANGLE} rotationAllowed={false} centerCoords={centerCoords} dataAttributes={{
    'data-e2e-id': `annotation-${rect.annotationLabel.title}-${rect.annotationType}`
  }}>
      <rect x={rect.data.x} y={rect.data.y} height={rect.data.height} width={rect.data.width} stroke={annotationStyle.strokeColor} fill={annotationStyle.fillColor} fillOpacity={0.2} style={{
      strokeWidth: annotationStyle.strokeWidth
    }} {...getStylesForStylingType(ANNOTATION_SHAPE_STYLING_TYPE.DASHED_BORDER)} />
    </Shape>;
};
export default BoundingBox;